var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterTiles1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 72,
    viewBox: "0 0 1440 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1135_505)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4,
    width: 63,
    height: 64,
    fill: "#CB5DBC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    width: 63,
    height: 64,
    fill: "#95AEB1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311,
    width: 63,
    height: 64,
    fill: "#89448B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374,
    width: 63,
    height: 64,
    fill: "#84F0F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    width: 63,
    height: 64,
    fill: "#61727A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626,
    width: 63,
    height: 64,
    fill: "#E8364D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 689,
    width: 63,
    height: 64,
    fill: "#47B57A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 878,
    width: 63,
    height: 64,
    fill: "#91517B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1130,
    width: 63,
    height: 64,
    fill: "#B600DC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193,
    width: 63,
    height: 64,
    fill: "#EE8CA0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1256,
    width: 63,
    height: 64,
    fill: "#B6E058"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1135_505",
    x: -8,
    y: 0,
    width: 1457,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1135_505"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1135_505",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTiles1);
export default __webpack_public_path__ + "static/media/FooterTiles1.7e3cafd3ee0f6236780df746d6452d10.svg";
export { ForwardRef as ReactComponent };